/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardEntity,
    CardEntityFromJSON,
    CardEntityFromJSONTyped,
    CardEntityToJSON,
} from './CardEntity';

/**
 * 
 * @export
 * @interface TransactionEntity
 */
export interface TransactionEntity {
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    transactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    personId?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionEntity
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof TransactionEntity
     */
    transactionDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransactionEntity
     */
    registrationDateTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    careProvider?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    careProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    registeringCareProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    careUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    careUnitId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionEntity
     */
    statusReason?: string;
    /**
     * 
     * @type {CardEntity}
     * @memberof TransactionEntity
     */
    card?: CardEntity;
}

export function TransactionEntityFromJSON(json: any): TransactionEntity {
    return TransactionEntityFromJSONTyped(json, false);
}

export function TransactionEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'transactionId': !exists(json, 'transactionId') ? undefined : json['transactionId'],
        'personId': !exists(json, 'personId') ? undefined : json['personId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'transactionDate': !exists(json, 'transactionDate') ? undefined : (new Date(json['transactionDate'])),
        'registrationDateTime': !exists(json, 'registrationDateTime') ? undefined : (new Date(json['registrationDateTime'])),
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'careProvider': !exists(json, 'careProvider') ? undefined : json['careProvider'],
        'careProviderId': !exists(json, 'careProviderId') ? undefined : json['careProviderId'],
        'registeringCareProviderId': !exists(json, 'registeringCareProviderId') ? undefined : json['registeringCareProviderId'],
        'careUnit': !exists(json, 'careUnit') ? undefined : json['careUnit'],
        'careUnitId': !exists(json, 'careUnitId') ? undefined : json['careUnitId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusReason': !exists(json, 'statusReason') ? undefined : json['statusReason'],
        'card': !exists(json, 'card') ? undefined : CardEntityFromJSON(json['card']),
    };
}

export function TransactionEntityToJSON(value?: TransactionEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'transactionId': value.transactionId,
        'personId': value.personId,
        'amount': value.amount,
        'transactionDate': value.transactionDate === undefined ? undefined : (value.transactionDate.toISOString().substr(0,10)),
        'registrationDateTime': value.registrationDateTime === undefined ? undefined : (value.registrationDateTime.toISOString()),
        'carePrincipalId': value.carePrincipalId,
        'careProvider': value.careProvider,
        'careProviderId': value.careProviderId,
        'registeringCareProviderId': value.registeringCareProviderId,
        'careUnit': value.careUnit,
        'careUnitId': value.careUnitId,
        'status': value.status,
        'statusReason': value.statusReason,
        'card': CardEntityToJSON(value.card),
    };
}

